import { ModuleWithProviders, NgModule } from '@angular/core';
import { Firestore } from 'firebase/firestore';
import { FIRESTORE } from './firestore.tokens';

export interface FirestoreModuleAsyncConfig {
	deps?: any[];
	useFactory: (...args: any[]) => Firestore;
}

@NgModule()
export class FirestoreModule {
	static forRootAsync(config: FirestoreModuleAsyncConfig): ModuleWithProviders<FirestoreModule> {
		return {
			ngModule: FirestoreModule,
			providers: [
				{
					provide: FIRESTORE,
					useFactory: config.useFactory,
					deps: config.deps || [],
				},
			],
		};
	}
}
